import Slider from './slider';

class Photos extends Slider {

    slideFunc(slide) {
        this.slides.removeClass('_next _prev');
        this.root[0].offsetHeight; // задержка
        this.current.removeClass('_active').addClass('_prev');
        this.current = slide.addClass('_active');
        if (this.current.next().length) {
            this.current.next().addClass('_next');
        } else {
            this.slides.eq(0).addClass('_next');
        }
    }

}

let photos = new Photos({selector: '.js-photos-slider'});

export default photos;